const defaultValues = {
	info: {
		year: '2022',
		income: '1,234.00',
		currency: '$',
	},
	invoice: {
		corrected: false,
		payers: {
			companyName: 'Company name',
			address: 'Company address',
			city: 'Company city',
			state: 'State',
			zipCode: '123456',
			TIN: '0000-00',
		},
		recipients: {
			name: 'Recipient name',
			address: 'Recipient address',
			city: 'Recipient city',
			state: 'State',
			zipCode: '123456',
			TIN: '0000-00',
			accountNumber: '0000-00000-0',
			FATCA: false,
		},
		values: {
			rents: '',
			royalties: '',
			otherIncome: '',
			federalIncomeTaxWithHeld: '',
			fishingBoatProceeds: '',
			medicalHealthCare: '',
			more5000Sales: false,
			paymentsDividendsOrInterest: '',
			cropInsuranceProceeds: '',
			field11: '',
			grossProceedsToAttorney: '',
			section409ADeferrals: '',
			excessGoldenPayments: '',
			nonQualifiedDeferredCompensation: '',
			stateTaxWithheldA: '',
			stateTaxWithheldB: '',
			statePayersA: '',
			statePayersB: '',
			stateIncomeA: '',
			stateIncomeB: '',
			illegalAgreement: false,
			terms: false,
		},
	},
}

export default defaultValues
